import { ProjectAttributeBase } from './base/project-attribute-base';

export class ProjectAttribute extends ProjectAttributeBase { }